import React from 'react';

type Propstype = {
  children: React.ReactNode;
  className?: string;
};

export const Small = ({ children, className = '', ...props }: Propstype) => {
  const tw = {
    small: 'text-sm leading-5 font-normal text-gray-500',
  };
  return (
    <h5 {...props} className={tw.small + ' ' + className}>
      {children}
    </h5>
  );
};
